// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","inner":"Footer_inner__CVEiR"};